import React, { useMemo } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

function convertLocalToUTCDate(date) {
    if (!date || isNaN(new Date(date))) {
        return date;
    }
    return moment.utc(moment(date).format('YYYY-MM-DD')).toDate();
}

export default function UTCDatePicker({ selected, onChange, ...props }) {
  const selectedDate = useMemo(() => selected ? moment(selected).toDate() : selected, [selected])

  return (
    <DatePicker
      onChange={date => onChange(convertLocalToUTCDate(date))}
      selected={selectedDate}
      {...props}
    />
  )
}